<div class="plan-picker">
    <span class="plan-picker__label" id="plan-picker-label">Select a Monthly plan</span>
    <span class="plan-picker__helper-label" style="font-size: 12px; font-style: italic;">(All plans have a {{ platformFeePlan?.amountPerCredit | currency }} processing fee included)</span>
    <div class="plan-picker__grid" role="radiogroup" aria-labelledby="plan-picker-label">
        @for (plan of sortedPlansByAmount; track plan) {
        <div class="plan-card" [class.plan-card--selected]="plan === inputSelectedPlan" role="radio"
            [attr.aria-checked]="plan === inputSelectedPlan" tabindex="0" (click)="selectPlan(plan)"
            (keydown.enter)="selectPlan(plan)" (keydown.space)="selectPlan(plan); $event.preventDefault()">
            <!-- <div class="plan-card__header">
                <h3 class="plan-card__title">{{ plan.name }}</h3>
            </div> -->
            <div class="plan-card__body">
                <p class="plan-card__price">
                    <span class="plan-card__period">Up to {{ plan.creditsPerMonth }} statements</span>
                    <span class="plan-card__period">per month</span>
                </p>
                <ul class="plan-card__features">
                    <span class="plan-card__credits"><b>{{ plan.amountPerMonth | currency }}</b></span>
                    <li>All in price: <b>{{ plan.amountPerMonth + 20 | currency }}</b></li>
                    <li>Additional credits can be purchased as needed</li>
                </ul>
            </div>
            <div class="plan-card__actions">
                <button class="btn-primary" aria-hidden="true">
                    {{ plan === inputSelectedPlan ? 'Selected' : 'Select' }}
                </button>
            </div>
        </div>
        }
        <div class="plan-card plan-card--contact" tabindex="0">
            <div class="plan-card__body">
                <p class="plan-card__price">
                    <span class="plan-card__period">More than 50 statements</span>
                    <span class="plan-card__period">per month</span>
                </p>
                <span class="plan-card__credits">Contact Us!</span>
            </div>

        </div>
    </div>
    @if (!inputSelectedPlan) {
    <p class="plan-picker__hint">Please select a plan</p>
    }
</div>